import * as React from 'react';
import MainLayout from '../main-layout';

type ShareablePreviewLayoutProps = {
  children: React.ReactNode;
};

const ShareablePreviewLayout = ({ children }: ShareablePreviewLayoutProps) => (
  <MainLayout className="items-center" childrenClassName="max-w-playground" displayHeader={false}>
    {children}
  </MainLayout>
);

export default ShareablePreviewLayout;
